import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cream-200 px-4 py-20" data-id="element-46" data-mp="1lazcje4mzhfh">
      <div className="mx-auto max-w-2xl" data-id="element-47" data-mp="1l9fqf6wauc5s">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-ink sm:text-[32px]" data-id="element-48" data-mp="1gdqpp08jmp7w">
          <span aria-hidden="true" data-id="element-49" data-mp="2dz4whynv92e9">❓</span> Domande frequenti
        </h2>

        <ul className="mt-9 space-y-2.5" data-id="element-50" data-mp="290tidbqjg5q8">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.q} className="rounded-xl border border-cream-300 bg-white" data-id="element-51" data-mp="240fd21gbn9vw" data-mpi={i}>
                <h3 data-id="element-52" data-mp="1z2nkd57urjqn">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-53" data-mp="1z59qr1j0bt7a">
                    <span className="font-sans text-[13px] font-semibold text-ink" data-id="element-54" data-mp="ug9cby2peidp">{faq.q}</span>
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-55" data-mp="kiuvvygs5tle" /> : <PlusIcon className="h-4 w-4 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-56" data-mp="6qwrg0y0klvk" />}
                  </button>
                </h3>
                {isOpen && <p className="border-t border-cream-200 px-5 py-4 font-sans text-[12.5px] leading-relaxed text-ink-soft" data-id="element-57" data-mp="3sz6hlzfr4tmi">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}